export const MONOCHROME_WHITE = '#FFFFFF';
export const STY_GREY_7 = '#D4D4D4';
export const MONOCHROME_DARK_SILVER = '#BFBFBF';
export const MONOCHROME_MED_GRAY = '#7A7A7A';
export const MONOCHROME_DARK_GRAY = '#5C5C5C';
export const MONOCHROME_BLACK = '#000000';
export const THEMES_BRAND = '#BE1621';
export const THEMES_BRAND_LIGHT = '#98121A80';
